export const cleanAndTruncateLabels = (input, maxLength) => {
  if (typeof input === 'undefined') {
    return '';
  }

  let cleanedString = input
    ?.replace(/\*/g, '')
    ?.replace(/\s*\([^)]{2,}\)\s*/g, '') // Remove anything with more than one character in parentheses
    ?.replace(/([^\w\s()/+'-])+/g, ''); // Remove punctuation but keep single characters in parentheses and slashes

  if (cleanedString?.length > maxLength) {
    const truncatedString = cleanedString.substring(0, maxLength);
    const lastSpaceIndex = truncatedString.lastIndexOf(' ');

    cleanedString = lastSpaceIndex > -1 ? truncatedString.substring(0, lastSpaceIndex) : truncatedString;
    cleanedString += '... ';
  }

  return cleanedString + ': ';
};

const scrollProps = { behavior: 'smooth', block: 'center' };

export const scrollById = (errorId, modalId, typeSuffix) => {
  if (!errorId) return;

  const inputElement = modalId
    ? document.getElementById(modalId).querySelector(`#${errorId}`)
    : document.getElementById(errorId);
  const radioInput = inputElement.getElementsByTagName('input')[0];
  const currentInput = radioInput || inputElement;

  currentInput.focus();
  currentInput.scrollIntoView(scrollProps);
};
